import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SafeHtmlPipe } from 'src/app/templates/safe.pipe';
import { ContentService } from '../../../services/content.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-team-member-characteristics',
  templateUrl: './team-member-characteristics.component.html',
  styleUrls: ['./team-member-characteristics.component.scss', '../../../../styles/templates/_purple-pulsing-cards.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [SafeHtmlPipe, CommonModule],
})
export class TeamMemberCharacteristicsComponent implements OnInit {
  @Input() mbtiType: string;
  isApiDataLoaded: boolean = false;
  reportContent: string;

  constructor(private contentService: ContentService) {}

  ngOnInit() {
    this.contentService.getReport('TeamsIndividualCharacteristics', this.mbtiType).subscribe((data) => {
      this.reportContent = data.content;
      this.isApiDataLoaded = true;
    });
  }
}
